export const environment = {
  name: 'development',
  production: false,
  enableDevTools: true,
  logLevel: 'debug',
  googleTagManagerId: 'GTM-MB77VRN2',
  BookDemo:
    'https://outlook.office365.com/owa/calendar/BearingPointDemandSens@be4you.onmicrosoft.com/bookings/',
  products: {
    core: {
      name: 'Core',
      email: 'marc.hispa@bearingpoint.com',
    },
    codex: {
      url: 'https://codex.demandsens.io',
      name: 'Codex',
      email: 'marc.hispa@bearingpoint.com',
      authenticationConfig: {
        url: 'auth.bookinsight.demandsens.io',
        realm: 'codex',
        clientId: 'codex-api',
        redirect: 'app',
      },
    },
    bookinsight: {
      url: 'https://bookinsight.demandsens.cloud',
      support_email: 'bookinsight@demandsens.io',
      authenticationConfig: {
        url: 'https://auth.bookinsight.demandsens.cloud',
        realm: 'dmsbi',
        clientId: 'dmsbi-api',
        redirect: 'app',
      },
      legals: {
        TOMS: 'https://bookinsight.demandsens.cloud/api/public/legal/TOMS_BookInsight.pdf',
        DPA: 'https://bookinsight.demandsens.cloud/api/public/legal/DPA_BookInsight.pdf',
        AI_Transparency_Notice:
          'https://bookinsight.demandsens.cloud/api/public/legal/AI_Transparency_Notice_BookInsight.pdf',
        Terms_and_Conditions_General_Part:
          'https://bookinsight.demandsens.cloud/api/public/legal/Terms_and_Conditions_-_General_Part_BookInsight.pdf',
        Terms_and_Conditions_Product_Specific:
          'https://bookinsight.demandsens.cloud/api/public/legal/Terms_and_Conditions_-_Product_Specific_BookInsight.pdf',
        Privacy_and_Cookies_Notice:
          'https://bookinsight.demandsens.cloud/api/public/legal/Privacy_and_Cookies_Notice_Bookinsight.pdf',
      },
    },
  },
};
